import React, { useEffect, useState, useContext } from 'react'
import { connect, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { ThemeContext } from 'styled-components'

// ui-kit
import { useWindowSize } from '@navent-jobs/ui-kit/hooks/window-size'
import { Icon } from '@navent-jobs/ui-kit/components/icon'
import Text from '@navent-jobs/ui-kit/components/text'

// components
import SocialShare from '../../../../../../../components/SocialShare'
import BottomSidebar from '../../../../../../../components/BottomSidebar'
import CorazonAnimado from '../../../../../../../components/corazon-animado'

// mixins
import {
  OptionsWrapper,
  ButtonCustom,
  CustomButtonMenu,
  Divider,
  MenuContainer,
  MenuOptsContainer,
  IconContainer,
  CorazonContainer,
  ButtonPostularme,
  Container,
} from './mixins'

// constants
import features from '../../../../../../../constants/features-per-country'
import { BASE_URL, NOMBRE_SITIO, SITE_ID } from '../../../../../../../constants'
import { DataLayer } from '../../../../../../../constants/gtm-events-compartir-aviso'

// store
import { setSaveJobPosting, deleteSaveJobPosting } from '../../../../../../../redux/actions/save-job-posting'
import { DataLayers } from '../../../../../../../constants/gtm-events-avisos-guardados'
import { showSnackbar } from '../../../../../../../redux/actions/applicant/curriculum/snackbar'
import SeguirEmpresaLink from '../../FollowCompany/index'
import { handleSmoothScroll } from '../../../../../../../hooks/handle-smooth-scroll'

// eslint-disable-next-line prettier/prettier
const saveJobPostingEnabled = features[SITE_ID || 'BMAR']?.saveJobPosting?.enabled

const handleComplaintClick = (isUserLoggedIn, setVisibleModal) => {
  if (isUserLoggedIn) {
    setVisibleModal && setVisibleModal('modal-denunciar-aviso')
  } else {
    window.location.assign(`/login?returnTo=${window.location.pathname}`)
  }
}

const handleSavePosting = ({ isUserLoggedIn, setSavePosting, savePosting, dispatch, id }) => {
  if (isUserLoggedIn) {
    setSavePosting(!savePosting)

    if (!savePosting) {
      DataLayers.guardarAvisoFicha(window?.location?.pathname)
      dispatch(setSaveJobPosting({ id, savePosting }))
    } else {
      dispatch(deleteSaveJobPosting({ id, savePosting }))
    }
  } else {
    window.location.assign(`/login?returnTo=${window.location.pathname}`)
  }
}

const Component = ({
  aviso,
  guardado,
  isUserLoggedIn,
  setVisibleModal,
  saveJobPostingStates,
  showAnchorPostular = false,
  productoLookAndFeel = {},
  postulacionRapida = false,
  postApply,
  activeAviso,
}) => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { colors } = useContext<{ colors }>(ThemeContext)
  const { isMobile, isTabletPortrait } = useWindowSize()
  const isMobileOrPortrait = isMobile || isTabletPortrait

  const buttonSaveJobPostingDisabled = !aviso || aviso.estado === 'offline'
  const isOrigenZJ = aviso?.origenAviso === 'ZONAJOBS'

  const [savePosting, setSavePosting] = useState(false)
  const [visibleMenu, setVisibleMenu] = useState(false)

  const id: number | string = aviso?.id

  // constants for social share
  const shareUrl = BASE_URL + aviso?.seoFriendlyUrl
  const shareTitle = `${aviso?.titulo} en ${aviso?.empresa?.denominacion}`
  const shareHelperDescription = `Te comparto este aviso de ${NOMBRE_SITIO}`

  const postulado = postApply?.estado?.toUpperCase() === "REALIZADA" || activeAviso?.postulacion?.estado === "REALIZADA"

  const Denunciar = ({ showLabel = false }) =>
    !isOrigenZJ ? (
      <ButtonCustom
        onClick={() => handleComplaintClick(isUserLoggedIn, setVisibleModal)}
        buttonoptions={{ size: 'small', variant: 'black', type: 'link' }}
      >
        <IconContainer>
          <Icon name="icon-light-alert-triangle" size={showLabel ? '16' : '24'} />
          {showLabel && (
            <Text size="sm" fontWeight="semibold">
              {t('fichaAviso.acciones.denunciar')}
            </Text>
          )}
        </IconContainer>
      </ButtonCustom>
    ) : null

  const Compartir = ({ showLabel = false }) => (
    <SocialShare
      label={showLabel ? t('fichaAviso.acciones.compartir') : undefined}
      onClick={() => DataLayer.handlerShareAvisoIntentionTraking()}
      onClickShare={DataLayer.handlerShareAvisoTraking}
      shareUrl={shareUrl}
      shareTitle={shareTitle}
      shareHelperDescription={shareHelperDescription}
      modalTitle={t('share.modal.fichaAviso.title')}
    />
  )

  useEffect(() => {
    setSavePosting(guardado)
  }, [guardado])

  useEffect(() => {
    if (saveJobPostingStates?.success) {
      dispatch(showSnackbar('Guardaste este aviso', 'icon-bold-heart'))
    }
  }, [saveJobPostingStates?.success])

  return (
    <OptionsWrapper>
      {!isMobileOrPortrait && (
        <>
        {!postulado && (
          <ButtonPostularme
          showAnchorPostular={showAnchorPostular && !buttonSaveJobPostingDisabled}
          buttonoptions={{
            variant: isOrigenZJ ? 'zonajobs' : 'primary',
            block: true,
            size: 'medium',
          }}
          productoLookAndFeel={productoLookAndFeel}
          onClick={() => handleSmoothScroll('#section-postular-bar', 200)}
        >
          {postulacionRapida ? (
            <Container>
              <Icon name="icon-light-flash-on" color={colors.gray0} />
              {t('fichaAviso.postulacionRapida')}
            </Container>
          ) : (
            t('fichaAviso.postularme')
          )}
        </ButtonPostularme>
        )}

          <Denunciar />
          <Compartir />
        </>
      )}

      {saveJobPostingEnabled && !isOrigenZJ && (
        <CorazonContainer>
          <CorazonAnimado
            disabled={buttonSaveJobPostingDisabled}
            savePosting={savePosting}
            onClick={() => handleSavePosting({ isUserLoggedIn, setSavePosting, savePosting, dispatch, id })}
          />
        </CorazonContainer>
      )}

      {isMobileOrPortrait && (
        <>
          <CustomButtonMenu onClick={() => setVisibleMenu(true)}>
            <Icon name="icon-light-more-vertical" size="24" color={colors.grey72} />
          </CustomButtonMenu>

          <BottomSidebar
            onClose={() => setVisibleMenu(false)}
            width={991}
            animation="fadeInSlideUp"
            height={396}
            visible={visibleMenu}
          >
            <MenuContainer>
              <Divider />
              <MenuOptsContainer>
                {aviso && <SeguirEmpresaLink aviso={aviso} isMenu />}
                <Denunciar showLabel />
                <Compartir showLabel />
              </MenuOptsContainer>
            </MenuContainer>
          </BottomSidebar>
        </>
      )}
    </OptionsWrapper>
  )
}

const states = ({ saveJobPostingStore, postularBarStore, activeAvisoStore }) => ({
  saveJobPostingStates: saveJobPostingStore?.setSaveJobPosting.states,
  postApply: postularBarStore?.PostToApply.data,
  activeAviso: activeAvisoStore,
})

export default connect(states)(Component)
